exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".viewer3d{width:100%;height:100%;position:relative}", ""]);

// exports
